import main from './main.vue'
const commonNav= {
  install:function(Vue) {
    Vue.component(main.name, main)
  }
}
// 导出该组件
export default commonNav